// components/auth/ForgotPassword.tsx
import React, { useState } from "react";
import { myMutation } from "../hooks/myMutation";
import { MY_ENDPOINTS } from "@vehidhi/shared";

export const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);

  const forgotPassword = myMutation({
    endpoint: MY_ENDPOINTS.AUTH_ENDPOINTS.FORGOT_PASSWORD?.path || "/api/auth/forgot-password",
    method: "POST",
    auth: false,
    onSuccess: () => {
      setSuccess(true);
    },
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    forgotPassword.mutate({ email });
  };

  if (success) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full space-y-8 text-center">
          <div className="bg-green-50 p-4 rounded-lg">
            <p className="text-green-800">
              If an account exists with {email}, you will receive a password reset link.
            </p>
            <a href="/login" className="mt-4 inline-block text-indigo-600 hover:text-indigo-800">
              Back to login
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Reset Password
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Enter your email to receive a reset link
          </p>
        </div>

        {forgotPassword.error && (
          <div className="bg-red-50 p-3 rounded">
            <p className="text-red-700 text-sm">{(forgotPassword.error as any)?.message || "Failed to send reset link"}</p>
          </div>
        )}

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            placeholder="Email address"
          />

          <button
            type="submit"
            disabled={forgotPassword.isPending}
            className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50"
          >
            {forgotPassword.isPending ? "Sending..." : "Send Reset Link"}
          </button>
        </form>
      </div>
    </div>
  );
};